var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcDialog',{staticClass:"empty-jwt-info-dialog",attrs:{"name":_vm.dialogName,"buttons":_vm.buttons},on:{"update:open":function($event){return _vm.$emit('close', false)}}},[_c('div',{staticClass:"onlyoffice-popup-info"},[_c('p',[_vm._v(_vm._s(_vm.successText))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.warningHtml)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }